import React from "react";
import { PropTypes } from "prop-types";
import { Box, Switch, Typography } from "@mui/material";

const DualLabelSwitch = ({
  onLabel,
  offLabel,
  checked,
  disabled,
  onChange,
  color,
  ariaLabel,
  label
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flex={1}
      data-qa="dual-label-switch-container"
    >
      {label && (
        <Typography
          variant="subtitle1"
          component="label"
          htmlFor={label}
          sx={{ mt: -0.25 }}
        >
          {label}
        </Typography>
      )}
      <Box display="flex" alignItems="center">
        <Typography
          color={checked ? "textSecondary" : "textPrimary"}
          variant="subtitle2"
          data-qa="dual-label-switch-off-label"
        >
          {offLabel}
        </Typography>
        <Switch
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          color={color}
          inputProps={{ "aria-label": ariaLabel }}
          data-qa="dual-label-switch"
          id={label}
        />
        <Typography
          color={!checked ? "textSecondary" : "textPrimary"}
          variant="subtitle2"
          data-qa="dual-label-switch-on-label"
        >
          {onLabel}
        </Typography>
      </Box>
    </Box>
  );
};

export default DualLabelSwitch;

DualLabelSwitch.propTypes = {
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  onChange: PropTypes.func,
  ariaLabel: PropTypes.string
};

DualLabelSwitch.defaultProps = {
  color: "primary"
};
